import { Button, Flex, Text } from '@mantine/core'
import { modals } from '@mantine/modals'

import removeEmailDomainFromUserUseCase from '../../hook/removeEmailDomainToUser.hook'

interface RemoveEmailDomainToUserProps {
  userEmailDomainId: string
}

const RemoveEmailDomainToUser = ({
  userEmailDomainId,
}: RemoveEmailDomainToUserProps) => {
  const { removeEmailDomain, isLoading } = removeEmailDomainFromUserUseCase({
    userEmailDomainId,
  })

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        removeEmailDomain()
      }}
    >
      <Text size="sm">Are you sure you want to remove the email domain?</Text>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button loading={isLoading} type="submit" variant="filled" color="red">
          Save
        </Button>
      </Flex>
    </form>
  )
}

export const removeEmailDomainFromUserModal = (userEmailDomainId: string) =>
  modals.open({
    title: 'Remove Email Domain',
    centered: true,
    children: <RemoveEmailDomainToUser userEmailDomainId={userEmailDomainId} />,
    radius: 'md',
  })
